import { render } from "./diamondRegionAdd.vue?vue&type=template&id=14af5c2f&scoped=true"
import script from "./diamondRegionAdd.vue?vue&type=script&lang=js"
export * from "./diamondRegionAdd.vue?vue&type=script&lang=js"

import "./diamondRegionAdd.vue?vue&type=style&index=0&id=14af5c2f&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./diamondRegionAdd.vue?vue&type=style&index=1&id=14af5c2f&lang=scss"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14af5c2f"]])

export default __exports__